// Modules
import axios from "axios";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

// Components
import PageContent from "containers/PageContent/PageContents";
import Footer from "components/Footer/Footer";
import PageLoading from "components/PageLoading/PageLoading";
import GlobalWkPageData from "components/GoogleTagMananger/GlobalWkPageData";
import GoogleTagManagerNoScript from "components/GoogleTagMananger/GoogleTagManagerNoScript";
import MetaTags from "components/MetaTags/MetaTags";

// Types
import {GetServerSideProps, GetServerSidePropsResult} from "next";
import { FormazioneSlugProps } from "interfaces/pages";

// Utils
import serverSideFunction from "utils/serverSideFunction";

// Containers
import CookieBanner from "components/CookieBanner/CookieBanner";
import GoogleTagManager from "components/GoogleTagMananger/GoogleTagManager";
import SchemaScript from "containers/PageContent/SchemaScript";
import HeaderContent from "containers/HeaderContent/HeaderContent";

// Constants
import {GENERIC_GTM_ID, TDM_META_TAGS} from "constants/pages";

export const getServerSideProps: GetServerSideProps<FormazioneSlugProps> = async (context) => {
	const serverSideProps: GetServerSidePropsResult<FormazioneSlugProps> = await serverSideFunction(context);
	return serverSideProps;
};

// Page
const FormazioneSlug = ({ categories, seoInformations, userInfo, searchResults, urlPath, activeFilters, isMobile }: FormazioneSlugProps): JSX.Element => {
	const [loading, setLoading] = useState<boolean>(true);
	const [APISSOCallCompleted, setAPISSOCallCompleted] = useState<boolean>(false);

	const router = useRouter();
	const { asPath } = router;

	useEffect(() => {
		const fetchData = async () => {
			try {
				const encodedRedirectUrl = encodeURIComponent(asPath);
				const response = await axios.get(`/${process.env.NEXT_PUBLIC_SEARCH_PATH_NAME}/api/handleSession?redirectUrl=${encodedRedirectUrl}`);
				const loginUrl = response.data.message;

				if (loginUrl) {
					window.location.replace(loginUrl);
				} else {
					setAPISSOCallCompleted(true);
					setLoading(false);
				}
			} catch (error) {
				console.error('SSO error: ', error);
				setLoading(false);
			}
		};
		fetchData();
	}, []);

	return (
		<>
			{loading && (
				<PageLoading/>
			)}
			<div style={{display: loading ? 'none' : 'block'}}>
				{/* <Head> */}
				<MetaTags metaTags={TDM_META_TAGS}/>
				<CookieBanner></CookieBanner>
				<GlobalWkPageData/>
				<GoogleTagManager gtmId={GENERIC_GTM_ID}></GoogleTagManager>
				<SchemaScript/>
				{/* </Head> */}
				<GoogleTagManagerNoScript gtmId={GENERIC_GTM_ID}></GoogleTagManagerNoScript>
				<div id="site-main">
					<HeaderContent userInfo={userInfo} APISSOCallCompleted={APISSOCallCompleted}/>
					<PageContent urlPath={urlPath}/>
					<Footer htmlFooter={userInfo.htmlFooter}/>
				</div>
			</div>
		</>
	);
};

export default FormazioneSlug;
